import { useMemo } from "react";
import { groupUsersBySection, ACCOUNT_SECTIONS } from "@/lib/accountStatus";

const FOLLOW_UP = {
  en_trial: "Mostrar días restantes; opcional solicitar licencia anticipada",
  trial_vencido: "Emitir o activar licencia; revisar solicitud PDF",
  licencia_activa: "Operación normal",
  licencia_solicitada: "Revisar solicitud y autorizar",
  comprador_titular: "Confirmar trial/licencia en system_config",
  pending_registration: "Esperar registro inicial",
};

/**
 * Vista diseñador — seguimiento de cuentas titular/comprador (sin emisión real).
 */
export default function BuyerRequestsDesignerPanel({ users = [], showAccountTrackingTitle = false }) {
  const buyers = useMemo(() => {
    const groups = groupUsersBySection(users);
    return [
      ...(groups[ACCOUNT_SECTIONS.BUYER_ACCOUNT] || []),
      ...(groups[ACCOUNT_SECTIONS.PENDING] || []).filter(
        (u) => u.is_admin_owner || u.needs_trial_registration || u.trial_bootstrap,
      ),
    ];
  }, [users]);

  return (
    <div
      className="rounded-sm border border-slate-200 bg-white p-5 space-y-4"
      data-testid="designer-buyer-requests-panel"
    >
      <div>
        <h3 className="text-sm font-semibold text-slate-900 m-0">
          {showAccountTrackingTitle ? "Seguimiento de cuentas" : "Solicitudes de compradores"}
        </h3>
        <p className="text-xs text-slate-500 mt-1 mb-0">
          {showAccountTrackingTitle
            ? "Titulares y registros pendientes según estatus de trial o licencia. Para revisar, aprobar o rechazar una solicitud formal, use la bandeja superior."
            : "Seguimiento de titulares y registros pendientes. La emisión de licencia sigue en Catálogo / Cartera (modo Distribuidor) o Centro BNT."}
        </p>
      </div>
      {buyers.length === 0 ? (
        <p className="text-xs text-slate-500 m-0">No hay cuentas comprador pendientes de seguimiento.</p>
      ) : (
        <div className="border border-slate-200 rounded-sm overflow-x-auto">
          <table className="w-full text-xs min-w-[720px]">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className="text-left px-3 py-2 text-[10px] uppercase font-semibold text-slate-500">Correo</th>
                <th className="text-left px-3 py-2 text-[10px] uppercase font-semibold text-slate-500">Nombre</th>
                <th className="text-left px-3 py-2 text-[10px] uppercase font-semibold text-slate-500">Estatus</th>
                <th className="text-left px-3 py-2 text-[10px] uppercase font-semibold text-slate-500">Prueba / licencia</th>
                <th className="text-left px-3 py-2 text-[10px] uppercase font-semibold text-slate-500">Siguiente acción</th>
              </tr>
            </thead>
            <tbody>
              {buyers.map((u) => {
                const st = u.account_status || {};
                const sub = u.subscription || {};
                const trialLic =
                  sub.mode === "licensed"
                    ? "Licencia"
                    : sub.reason === "trial_expired"
                      ? "Periodo de prueba vencido"
                      : sub.mode === "trial"
                        ? "En trial"
                        : "—";
                return (
                  <tr key={u.id} className="border-t border-slate-100">
                    <td className="px-3 py-2 font-mono text-[11px]">{u.email}</td>
                    <td className="px-3 py-2">{u.name || "—"}</td>
                    <td className="px-3 py-2">{st.label || "—"}</td>
                    <td className="px-3 py-2 text-slate-600">{trialLic}</td>
                    <td className="px-3 py-2 text-slate-600">
                      {st.suggested_action || FOLLOW_UP[st.code] || "Revisar en catálogo"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
